import { sha256 } from '@noble/hashes/sha2.js';
import { bytesToHex, concatBytes, utf8ToBytes } from '@noble/hashes/utils.js';

type HashInput = string | Uint8Array;

class BrowserHash {
  private chunks: Uint8Array[] = [];

  update(value: HashInput) {
    this.chunks.push(typeof value === 'string' ? utf8ToBytes(value) : value);
    return this;
  }

  digest(encoding: 'hex') {
    if (encoding !== 'hex') throw new Error('HŌTEI crypto adapter only supports hex digests');
    return bytesToHex(sha256(concatBytes(...this.chunks)));
  }
}

export function createHash(algorithm: string) {
  if (algorithm.toLowerCase() !== 'sha256') {
    throw new Error(`Unsupported browser hash algorithm: ${algorithm}`);
  }
  return new BrowserHash();
}
